import { Button, Form, Input, Modal } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import Empty from "../common/Empty";
import moment from "moment";
import CustomerLayout from "./Layout";
import CustomerHeader from "./Layout/topHeader";
import { responseNotification } from "../../utils/notify";
import { useSelector } from "react-redux";

const DriverUnsettleOrderList = () => {
  const { driverInfo } = useSelector((state) => (state as any)?.authReducer);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(undefined);
  const [status, setStatus] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [limit, setLimit] = useState(16);

  const [usersData, setUsersData] = useState({
    loading: false,
    data: null,
  });

  const [selectedUser, setSelectedUser] = useState(undefined);

  const fetchRef = useRef(null);
  const route = useParams();

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setStatus("");
    setMobileNumber("");
    form.resetFields();
  };

  const getUnsettledOrders = useCallback(async () => {
    setUsersData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/order/unsettle-order-for-delivery-man` +
          `?deliveryManId=${(route as any)?.id || ``}` +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setUsersData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setUsersData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [route, page, limit]);

  const onCashCollect = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      amount: data.amount * 1,
      note: data.note,
      deliveryManId: (route as any)?.id as string,
    };

    await fetch(
      `${process.env.REACT_APP_RIDER_API}/admin/transaction/cash-collection`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Cash Recieved Successfully!!!", "success");
          setVisible(!visible);
          form.resetFields();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  useEffect(() => {
    getUnsettledOrders();
  }, [getUnsettledOrders]);

  return (
    <React.Fragment>
      <CustomerLayout driverId={(route as any)?.id as string}>
        <div className="bg-white">
          <CustomerHeader
            leftarea={"Unsettled Orders"}
            rightarea={""}
          />

          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-list-items-inner-content">
                    <div className="single-product-wrapper">
                      <div className="single-product-heading">
                        <span>Date & Time</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Order ID</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Amount</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Status</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {usersData?.loading ? (
                  <Loading />
                ) : (
                  <div className="col-lg-12 product-table">
                    <div className="product-table-area">
                      {usersData?.data?.orders?.length ? (
                        usersData?.data?.orders?.map(
                          (order: any, index: any) => (
                            <React.Fragment key={index}>
                              {/* <Link to={`/users/${user?.id}`}> */}
                              <div
                                className="single-product-wrapper"
                                onClick={() => setSelectedUser(order)}
                              >
                                <div className="single-product">
                                  <span className="name text-nowrap text-capitalize">
                                    {moment(order?.createdAt).format("lll")}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">{order?.orderId}</span>
                                </div>

                                <div className="single-product">
                                  <span className="name">
                                    &#2547;{order?.total}
                                  </span>
                                </div>

                                <div className="single-product">
                                  <span
                                    className={`radius-btn ${order?.status?.toLowerCase()}-btn`}
                                  >
                                    {order?.status}
                                  </span>
                                </div>
                              </div>
                              {/* </Link> */}
                            </React.Fragment>
                          )
                        )
                      ) : (
                        <Empty data="Transactions" />
                      )}
                    </div>
                  </div>
                )}
              </div>

              <PaginationTwo
                {...usersData?.data}
                limit={limit}
                page={getPage(loc.search)}
              />
            </div>
          </div>
        </div>
      </CustomerLayout>

      <Modal
        title="Cash Collect"
        visible={!!visible}
        // okText="Recieve Cash"
        // onOk={onCashCollect}
        confirmLoading={loading}
        destroyOnClose={true}
        onCancel={() => {
          setVisible(!visible);
        }}
        footer={false}
      >
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
          onFinish={onCashCollect}
        >
          <Form.Item
            label="Enter Amount"
            name="amount"
            rules={[
              { required: true },
              {
                validator: async (_, value) => {
                  if (value > driverInfo?.balance) {
                    return Promise.reject(
                      new Error("Amount Must be Equal or less than Balance")
                    );
                  }
                },
              },
            ]}
          >
            <Input type="number" placeholder="Enter Collected Amount" />
          </Form.Item>

          <Form.Item name="note" label="Note" rules={[{ required: true }]}>
            <Input.TextArea
              placeholder="Please write some note or description..."
              rows={5}
            />
          </Form.Item>

          <Button htmlType="submit" type="primary">
            Recieve Cash
          </Button>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default DriverUnsettleOrderList;
